// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════
   PYATE CHATBOT — LIGHT THEME
   Matches store palette: navy #1b4f72, blue #1e7ab8, white
═══════════════════════════════════════════════════════ */
:root {
  --p-navy:       #1b4f72;
  --p-blue:       #1e7ab8;
  --p-light:      #e8f4fd;
  --p-lighter:    #f0f8ff;
  --p-border:     #cce3f5;
  --p-border-dk:  #93c5e8;
  --p-text:       #1a2e3d;
  --p-text-sec:   #3d6278;
  --p-text-muted: #7a9ab0;
  --p-white:      #ffffff;
  --p-card:       #f7fbff;
  --font: 'Sora', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* shimmer keyframe used by .skel */
@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ═══ FLOATING BUTTON ══════════════════════════════════ */
.chatbot-button {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  z-index: 999;           /* below navbar (1000+) */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #2196c4 0%, #1b5e8c 100%);
  box-shadow: 0 4px 20px rgba(30,122,184,0.5), 0 2px 8px rgba(0,0,0,.12);
  transition: transform .25s cubic-bezier(.34,1.56,.64,1), box-shadow .25s ease;
  animation: fabPulse 3s ease-in-out infinite;
  isolation: isolate;
}
.chatbot-button::before {
  content: '';
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(33,150,196,.2) 0%, transparent 70%);
  z-index: -1;
  animation: fabGlow 3s ease-in-out infinite;
}
@keyframes fabPulse {
  0%,100% { box-shadow: 0 4px 20px rgba(30,122,184,.5), 0 2px 8px rgba(0,0,0,.12); }
  50%      { box-shadow: 0 4px 28px rgba(30,122,184,.72), 0 2px 8px rgba(0,0,0,.12); }
}
@keyframes fabGlow {
  0%,100% { opacity:.5; transform:scale(1); }
  50%      { opacity:1;  transform:scale(1.12); }
}
.chatbot-button:hover {
  transform: translateY(-3px) scale(1.06);
  box-shadow: 0 8px 28px rgba(30,122,184,.6), 0 4px 12px rgba(0,0,0,.16);
}
.chatbot-button-icon { font-size: 22px; line-height: 1; color: #fff; }

/* ═══ CHAT WINDOW ══════════════════════════════════════
   z-index 998 — safely below navbar (typically 1000+)
══════════════════════════════════════════════════════ */
.chatbot-container {
  position: fixed;
  bottom: 90px;
  right: 24px;
  width: min(400px, calc(100vw - 32px));
  height: min(480px, calc(100vh - 160px));
  z-index: 998;
  background: var(--p-white);
  border-radius: 20px;
  border: 1px solid var(--p-border);
  box-shadow:
    0 0 0 1px rgba(30,122,184,.07),
    0 20px 60px rgba(27,78,114,.16),
    0 8px 24px rgba(0,0,0,.09);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: var(--font);
  animation: chatOpen .3s cubic-bezier(.22,1,.36,1);
}
/* colour bar top */
.chatbot-container::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1b5e8c, #2196c4, #38bdf8, #2196c4, #1b5e8c);
  z-index: 2;
}
@keyframes chatOpen {
  from { transform: translateY(20px) scale(.97); opacity: 0; }
  to   { transform: translateY(0)    scale(1);   opacity: 1; }
}

/* ═══ HEADER ═══════════════════════════════════════════ */
.chatbot-header {
  padding: 13px 15px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #1b5e8c 0%, #1e7ab8 100%);
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}
.chatbot-header-left   { display: flex; align-items: center; gap: 10px; }
.chatbot-avatar {
  width: 36px; height: 36px; border-radius: 10px;
  background: rgba(255,255,255,.18);
  border: 1.5px solid rgba(255,255,255,.3);
  display: grid; place-items: center;
  font-size: 17px; flex-shrink: 0;
}
.chatbot-header-titles { display: flex; flex-direction: column; gap: 2px; }
.chatbot-header h4 {
  margin: 0; font-size: 14px; font-weight: 700;
  color: #fff; letter-spacing: .1px;
}
.chatbot-subtitle {
  font-size: 11px; color: rgba(255,255,255,.88);
  display: flex; align-items: center; gap: 5px;
}
.chatbot-subtitle::before {
  content: ''; width: 6px; height: 6px; border-radius: 50%;
  background: #4ade80; box-shadow: 0 0 5px rgba(74,222,128,.8);
  animation: onlinePulse 2s ease-in-out infinite; flex-shrink: 0;
}
@keyframes onlinePulse { 0%,100%{opacity:1} 50%{opacity:.45} }
.close-btn-chat {
  background: inherit;
  align-content: center;
  border: 1.5px solid rgba(30,122,184,.72);
  color: #fff;
  width: 32px; height: 32px;
  border-radius: 50%;          /* circular — cleaner look */
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: grid; place-items: center;
  line-height: 1;
  transition: background .2s ease, transform .2s ease, border-color .2s ease;
  flex-shrink: 0;
}
.close-btn-chat:hover {
  background: rgba(30,122,184,.72);   /* red on hover */
  border-color: rgba(30,122,184,.72);
  color: white;
}

/* ═══ STATUS BAR ════════════════════════════════════════ */
.chatbot-status-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: #eff8ff;
  border-bottom: 1px solid #bfdbf7;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--p-blue);
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  animation: statusIn .2s ease;
}
@keyframes statusIn {
  from { opacity:0; transform:translateY(-4px); }
  to   { opacity:1; transform:translateY(0); }
}
.status-spinner {
  width: 13px; height: 13px;
  border: 2px solid #bfdbf7;
  border-top-color: var(--p-blue);
  border-radius: 50%;
  animation: spin .65s linear infinite;
  flex-shrink: 0;
}
@keyframes spin { to { transform:rotate(360deg); } }

/* ═══ MESSAGES AREA ═════════════════════════════════════ */
.chatbot-messages {
  flex: 1 1;
  padding: 14px 12px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background:
    radial-gradient(ellipse 70% 50% at 0% 0%, rgba(33,150,196,.04) 0%, transparent 60%),
    #f8fcff;
  scrollbar-width: thin;
  scrollbar-color: #bfdbf7 transparent;
  position: relative;
  z-index: 1;
}
.chatbot-messages::-webkit-scrollbar       { width: 4px; }
.chatbot-messages::-webkit-scrollbar-track { background: transparent; }
.chatbot-messages::-webkit-scrollbar-thumb { background: #bfdbf7; border-radius: 99px; }

/* ═══ DATE DIVIDER ══════════════════════════════════════ */
.chat-divider {
  display: flex; align-items: center; gap: 8px;
  font-size: 10px; font-weight: 600;
  color: var(--p-text-muted);
  letter-spacing: .6px; text-transform: uppercase;
  margin: 2px 0;
}
.chat-divider::before,
.chat-divider::after {
  content: ''; flex: 1 1; height: 1px; background: var(--p-border);
}

/* ═══ MESSAGE BUBBLES ═══════════════════════════════════ */
.message {
  max-width: 84%;
  padding: 9px 13px;
  border-radius: 14px;
  font-size: 13px;
  line-height: 1.55;
  word-break: break-word;
  position: relative;
  animation: msgIn .25s cubic-bezier(.22,1,.36,1);
}
@keyframes msgIn {
  from { opacity:0; transform:translateY(8px); }
  to   { opacity:1; transform:translateY(0); }
}
.message.user {
  align-self: flex-end;
  background: linear-gradient(135deg, #1e7ab8 0%, #1b5e8c 100%);
  color: #fff;
  border-bottom-right-radius: 4px;
  box-shadow: 0 3px 12px rgba(30,122,184,.28);
}
.message.bot {
  align-self: flex-start;
  background: var(--p-white);
  color: var(--p-text);
  border: 1px solid var(--p-border);
  border-bottom-left-radius: 4px;
  box-shadow: 0 2px 8px rgba(27,78,114,.07);
  max-width: 92%; /* wider for product cards */
}

/* markdown inside bot bubbles */
.message.bot p { margin: .28em 0; }
.message.bot p:first-child { margin-top: 0; }
.message.bot p:last-child  { margin-bottom: 0; }
.message.bot strong { color: var(--p-navy); font-weight: 700; }
.message.bot h3 {
  font-size: 10.5px; font-weight: 700; color: var(--p-blue);
  letter-spacing: .5px; text-transform: uppercase;
  margin: 0 0 8px; padding-bottom: 6px;
  border-bottom: 1px solid var(--p-border);
}
.message.bot hr  { border:none; border-top: 1px solid var(--p-border); margin: 8px 0; }
.message.bot a   { color: var(--p-blue); text-decoration: underline; text-underline-offset: 2px; }
.message.bot del { color: var(--p-text-muted); font-size: 11.5px; }
.message.bot ul,
.message.bot ol  { margin: 4px 0; padding-left: 16px; }
.message.bot li  { margin: 2px 0; }

/* error variant */
.message.error-msg {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

/* ═══ SKELETON SHIMMER ══════════════════════════════════ */
.skel {
  background: linear-gradient(90deg, #dbeafe 25%, #eff8ff 50%, #dbeafe 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
  display: block;
}

/* ═══ PRODUCT CARD ══════════════════════════════════════ */
.pyate-product-card {
  background: var(--p-card);
  border: 1px solid var(--p-border);
  border-radius: 12px;
  overflow: hidden;
  margin: 6px 0;
  transition: border-color .18s ease, box-shadow .18s ease;
}
.pyate-product-card:hover {
  border-color: var(--p-border-dk);
  box-shadow: 0 4px 16px rgba(27,78,114,.1);
}

/* image wrapper */
.pcard-img-wrap {
  width: 100%;
  height: 140px;
  background: var(--p-light);
  overflow: hidden;
}
.pcard-img-wrap img {
  width: 100%; height: 100%;
  object-fit: cover; display: block;
  transition: transform .25s ease;
}
.pyate-product-card:hover .pcard-img-wrap img { transform: scale(1.04); }

/* info section */
.pcard-body {
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.pcard-category {
  font-size: 10.5px; font-weight: 600;
  color: var(--p-text-muted);
  text-transform: uppercase; letter-spacing: .4px;
}
.pcard-name {
  font-size: 13.5px; font-weight: 700;
  color: var(--p-navy); line-height: 1.3;
}
.pcard-desc {
  font-size: 12px; color: var(--p-text-sec);
  line-height: 1.4; margin-top: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.pcard-price-row {
  display: flex; align-items: center;
  gap: 6px; flex-wrap: wrap; margin-top: 6px;
}
.pcard-price {
  font-size: 14.5px; font-weight: 700; color: var(--p-navy);
}
.pcard-mrp {
  font-size: 11.5px; color: var(--p-text-muted);
  text-decoration: line-through;
}
.pcard-badge {
  font-size: 10px; font-weight: 700;
  padding: 1px 7px; border-radius: 99px;
  background: #dcfce7; color: #15803d;
  border: 1px solid #bbf7d0;
}

/* ═══ CART ITEM ROW ════════════════════════════════════ */
.pyate-cart-item {
  display: flex; gap: 10px; align-items: center;
  background: var(--p-card);
  border: 1px solid var(--p-border);
  border-radius: 12px;
  padding: 9px 11px; margin: 4px 0;
  transition: border-color .18s ease;
}
.pyate-cart-item:hover { border-color: var(--p-border-dk); }

.ci-img {
  width: 52px; height: 52px;
  border-radius: 8px; overflow: hidden;
  flex-shrink: 0;
  background: var(--p-light);
  display: flex; align-items: center;
  justify-content: center; font-size: 20px;
}
.ci-img img {
  width: 100%; height: 100%;
  object-fit: cover; display: block;
}
.ci-info   { flex: 1 1; min-width: 0; }
.ci-name   {
  font-size: 13px; font-weight: 600; color: var(--p-navy);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ci-qty    { font-size: 11.5px; color: var(--p-text-sec); margin-top: 2px; }
.ci-price  { font-size: 13.5px; font-weight: 700; color: var(--p-blue); flex-shrink: 0; }

/* cart total row */
.cart-total {
  display: flex; justify-content: space-between;
  padding: 8px 4px 2px;
  border-top: 1px solid var(--p-border);
  margin-top: 4px;
  font-size: 13.5px; font-weight: 700; color: var(--p-navy);
}
.cart-total-amount { color: var(--p-blue); }

/* ═══ TYPING DOTS ══════════════════════════════════════ */
.message.bot.typing {
  display: inline-flex; align-items: center;
  gap: 5px; padding: 11px 15px; max-width: fit-content;
}
.typing span {
  width: 7px; height: 7px; border-radius: 50%;
  background: #93c5e8;
  animation: typeDot 1.4s ease-in-out infinite;
}
.typing span:nth-child(2) { animation-delay:.18s; background:var(--p-blue); }
.typing span:nth-child(3) { animation-delay:.36s; background:var(--p-navy); }
@keyframes typeDot {
  0%,80%,100% { transform:scale(.65); opacity:.4; }
  40%          { transform:scale(1.1); opacity:1; }
}

/* ═══ INPUT AREA ════════════════════════════════════════ */
.chatbot-input {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 11px;
  background: #fff;
  border-top: 1px solid var(--p-border);
  flex-shrink: 0; position: relative; z-index: 1;
}
.chatbot-input input {
  flex: 1 1; padding: 10px 14px;
  border: 1.5px solid var(--p-border);
  border-radius: 12px;
  font-family: var(--font); font-size: 13px;
  color: var(--p-text); background: var(--p-lighter);
  outline: none; caret-color: var(--p-blue);
  transition: border-color .2s ease, box-shadow .2s ease;
}
.chatbot-input input::placeholder { color: var(--p-text-muted); }
.chatbot-input input:focus {
  border-color: var(--p-blue); background: #fff;
  box-shadow: 0 0 0 3px rgba(30,122,184,.12);
}
.chatbot-input input:disabled { opacity: .6; cursor: not-allowed; }

.chatbot-send {
  width: 40px; height: 40px; flex-shrink: 0;
  border-radius: 11px; border: none;
  background: linear-gradient(135deg, #2196c4 0%, #1b5e8c 100%);
  color: #fff; cursor: pointer;
  display: grid; place-items: center; font-size: 15px;
  box-shadow: 0 3px 12px rgba(30,122,184,.35);
  transition: transform .2s cubic-bezier(.34,1.56,.64,1), box-shadow .2s ease, opacity .2s ease;
}
.chatbot-send:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 18px rgba(30,122,184,.45);
}
.chatbot-send:active:not(:disabled) { transform: scale(.95); }
.chatbot-send:disabled {
  opacity: .35; cursor: not-allowed; transform: none; box-shadow: none;
}

/* ═══ REDUCED MOTION ════════════════════════════════════ */
@media (prefers-reduced-motion: reduce) {
  *, .chatbot-button, .chatbot-container, .message {
    animation: none !important; transition: none !important;
  }
}

/* ═══ MOBILE ════════════════════════════════════════════ */
@media (max-width: 520px) {
  .chatbot-button    { right: 14px; bottom: 14px; width: 52px; height: 52px; }
  .chatbot-container {
    right: 8px; left: 8px; width: auto;
    bottom: 78px; height: calc(100svh - 140px); border-radius: 16px;
  }
}

/* ═══════════════════════════════════════════════════════════
   NOTIFICATION-STYLE CARDS  —  append these to Chatbot.css
   Matches the look of Notifications.js cards exactly
═══════════════════════════════════════════════════════════ */

/* ── Card list wrapper ── */
.notif-cb-cards-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
  width: 100%;
}

/* ── Single card  (mirrors .notification-item) ── */
.notif-cb-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 11px;
  background: #ffffff;
  border: 1px solid #e0e3e8;
  border-left: 4px solid #1a73e8;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  animation: notif-cb-in 0.22s ease both;
  font-family: 'DM Sans', sans-serif;
  overflow: hidden;
}

@keyframes notif-cb-in {
  from { opacity: 0; transform: translateY(5px); }
  to   { opacity: 1; transform: translateY(0); }
}

.notif-cb-card:hover {
  background: #f5f8ff;
  border-color: #c8cdd6;
  border-left-color: #1a73e8;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  transform: translateY(-1px);
}

/* stagger */
.notif-cb-card:nth-child(1)  { animation-delay: 0.03s; }
.notif-cb-card:nth-child(2)  { animation-delay: 0.06s; }
.notif-cb-card:nth-child(3)  { animation-delay: 0.09s; }
.notif-cb-card:nth-child(4)  { animation-delay: 0.12s; }
.notif-cb-card:nth-child(5)  { animation-delay: 0.15s; }
.notif-cb-card:nth-child(6)  { animation-delay: 0.18s; }
.notif-cb-card:nth-child(7)  { animation-delay: 0.21s; }
.notif-cb-card:nth-child(8)  { animation-delay: 0.24s; }
.notif-cb-card:nth-child(9)  { animation-delay: 0.27s; }
.notif-cb-card:nth-child(10) { animation-delay: 0.30s; }

/* ── Avatar / image ── */
.notif-cb-avatar { flex-shrink: 0; }

.notif-cb-img {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #e0e3e8;
  display: block;
}

.notif-cb-img-placeholder {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: #e8f0fe;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a73e8;
  border: 1px solid rgba(26,115,232,0.15);
}

/* ── Content ── */
.notif-cb-content {
  flex: 1 1;
  min-width: 0;
}

.notif-cb-name {
  font-size: 13px;
  font-weight: 700;
  color: #1c1e21;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notif-cb-sub {
  font-size: 11px;
  color: #a0a3a9;
  margin-top: 1px;
}

.notif-cb-desc {
  font-size: 11px;
  color: #65676b;
  font-style: italic;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notif-cb-price-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.notif-cb-price {
  font-size: 12.5px;
  font-weight: 700;
  color: #1c1e21;
}

.notif-cb-mrp {
  font-size: 11px;
  color: #a0a3a9;
  text-decoration: line-through;
}

.notif-cb-discount {
  font-size: 11px;
  font-weight: 600;
  color: #2e7d32;
}

.notif-cb-qty {
  font-size: 11px;
  color: #65676b;
  background: #f0f2f5;
  border: 1px solid #e0e3e8;
  padding: 1px 6px;
  border-radius: 100px;
}

.notif-cb-date {
  font-size: 10.5px;
  color: #a0a3a9;
}

/* ── Add to cart button ── */
.notif-cb-action-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 11px;
  background: #1a73e8;
  color: #fff;
  border: none;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 2px 8px rgba(26,115,232,0.18);
  white-space: nowrap;
}

.notif-cb-action-btn:hover {
  background: #1558b0;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(26,115,232,0.25);
}

/* ── Status / label badges ── */
.notif-cb-badge {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 9px;
  border-radius: 100px;
  white-space: nowrap;
}

.notif-cb-badge-cart {
  background: #e8f0fe;
  color: #1a73e8;
  border: 1px solid rgba(26,115,232,0.2);
}

.notif-cb-badge-pending {
  background: #fff3e0;
  color: #e65100;
  border: 1px solid rgba(230,81,0,0.2);
}

.notif-cb-badge-delivered {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid rgba(46,125,50,0.2);
}

.notif-cb-badge-shipped {
  background: #e3f2fd;
  color: #1565c0;
  border: 1px solid rgba(21,101,192,0.2);
}
/* ═══════════════════════════════════════════════════════
   CHATBOT MOBILE FULLSCREEN FIX — append to Chatbot.css
   Fixes clipped send button + full screen on mobile
═══════════════════════════════════════════════════════ */

@media (max-width: 768px) {
  .chatbot-container {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    height: 100dvh !important;
    max-width: 100% !important;
    max-height: 100% !important;
    border-radius: 0 !important;
    z-index: 9999 !important;
    display: flex;
    flex-direction: column;
    overflow: hidden !important;
  }

  .chatbot-messages {
    flex: 1 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Input row — no clipping, full width, proper padding */
  .chatbot-input {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    padding: 10px 12px !important;
    padding-bottom: max(10px, env(safe-area-inset-bottom)) !important;
    background: #fff !important;
    border-top: 1px solid #e0e3e8 !important;
    position: sticky !important;
    bottom: 0 !important;
    z-index: 10000 !important;
    overflow: visible !important;
  }

  /* Text input takes all available space */
  .chatbot-input input {
    flex: 1 1 !important;
    min-width: 0 !important;
    width: 0 !important;
  }

  /* Send button — fixed size, never shrinks or clips */
  .chatbot-send {
    flex-shrink: 0 !important;
    width: 42px !important;
    height: 42px !important;
    min-width: 42px !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .chatbot-button {
    z-index: 9998 !important;
  }
}
/* ═══ LANGUAGE FAB ══════════════════════════════════════
   Floats above the chat button, same right-edge alignment
══════════════════════════════════════════════════════ */
.lang-fab-wrap {
  position: fixed;
  bottom: 92px;      /* sits just above the 56px chat button + 24px gap */
  right: 24px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.lang-fab-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 13px;
  border-radius: 99px;
  border: 1.5px solid rgba(30,122,184,0.35);
  background: #fff;
  color: #1e7ab8;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(30,122,184,0.18), 0 1px 4px rgba(0,0,0,0.08);
  transition: transform .2s ease, box-shadow .2s ease, background .2s ease;
  white-space: nowrap;
}
.lang-fab-btn:hover {
  background: #e8f4fd;
  transform: translateY(-2px);
  box-shadow: 0 4px 18px rgba(30,122,184,0.28);
}

/* dropdown menu */
.lang-fab-menu {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #fff;
  border: 1px solid #cce3f5;
  border-radius: 12px;
  padding: 6px;
  box-shadow: 0 8px 28px rgba(27,78,114,0.14), 0 2px 8px rgba(0,0,0,0.08);
  animation: langMenuIn .18s cubic-bezier(.22,1,.36,1);
  min-width: 120px;
}
@keyframes langMenuIn {
  from { opacity: 0; transform: translateY(6px) scale(.97); }
  to   { opacity: 1; transform: translateY(0)   scale(1);   }
}

.lang-fab-option {
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #1a2e3d;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: background .15s ease, color .15s ease;
}
.lang-fab-option:hover {
  background: #e8f4fd;
  color: #1e7ab8;
}
.lang-fab-option.active {
  background: #1e7ab8;
  color: #fff;
  font-weight: 700;
}

/* mobile adjustments */
@media (max-width: 520px) {
  .lang-fab-wrap {
    right: 14px;
    bottom: 80px;
  }
}

/* ═══ GOOGLE TRANSLATE CONFLICT FIX ════════════════════
   Prevents chatbot button duplication when Google Translate
   toolbar is active (e.g. Kannada selected)
═══════════════════════════════════════════════════════ */

/* Stop Google Translate from cloning fixed elements */
.skiptranslate .chatbot-button,
.skiptranslate .chatbot-container,
.skiptranslate .lang-fab-wrap {
  display: none !important;
}

/* When translate bar pushes body down, keep button anchored */
body.translated-ltr .chatbot-button,
body.translated-rtl .chatbot-button {
  bottom: 24px !important;
  position: fixed !important;
}

/* Prevent the translate frame from overlapping the chat window */
.goog-te-banner-frame {
  z-index: 997 !important; /* below chatbot z-index 998 */
}

/* Neutralize body top shift Google Translate applies */
body.translated-ltr,
body.translated-rtl {
  top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Chatbot.css"],"names":[],"mappings":"AAEA;;;yDAGyD;AACzD;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA,mCAAmC;AACnC;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY,YAAY,yBAAyB;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,sEAAsE;EACtE,6EAA6E;EAC7E,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,4EAA4E;EAC5E,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,UAAU,qEAAqE,EAAE;EACjF,WAAW,sEAAsE,EAAE;AACrF;AACA;EACE,UAAU,UAAU,EAAE,kBAAkB,EAAE;EAC1C,WAAW,SAAS,GAAG,qBAAqB,EAAE;AAChD;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA,uBAAuB,eAAe,EAAE,cAAc,EAAE,WAAW,EAAE;;AAErE;;wDAEwD;AACxD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,uCAAuC;EACvC,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,iCAAiC;EACjC;;;8BAG4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,iDAAiD;AACnD;AACA,mBAAmB;AACnB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,+EAA+E;EAC/E,UAAU;AACZ;AACA;EACE,OAAO,sCAAsC,EAAE,UAAU,EAAE;EAC3D,OAAO,oCAAoC,IAAI,UAAU,EAAE;AAC7D;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACxE;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,iCAAiC;EACjC,wCAAwC;EACxC,aAAa,EAAE,mBAAmB;EAClC,eAAe,EAAE,cAAc;AACjC;AACA,yBAAyB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC1E;EACE,SAAS,EAAE,eAAe,EAAE,gBAAgB;EAC5C,WAAW,EAAE,oBAAoB;AACnC;AACA;EACE,eAAe,EAAE,4BAA4B;EAC7C,aAAa,EAAE,mBAAmB,EAAE,QAAQ;AAC9C;AACA;EACE,WAAW,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EACxD,mBAAmB,EAAE,uCAAuC;EAC5D,8CAA8C,EAAE,cAAc;AAChE;AACA,yBAAyB,QAAQ,SAAS,EAAE,IAAI,WAAW,EAAE;AAC7D;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;EACxC,WAAW;EACX,WAAW,EAAE,YAAY;EACzB,kBAAkB,WAAW,4BAA4B;EACzD,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa,EAAE,mBAAmB;EAClC,cAAc;EACd,0EAA0E;EAC1E,cAAc;AAChB;AACA;EACE,gCAAgC,IAAI,iBAAiB;EACrD,kCAAkC;EAClC,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,OAAO,SAAS,EAAE,0BAA0B,EAAE;EAC9C,OAAO,SAAS,EAAE,uBAAuB,EAAE;AAC7C;AACA;EACE,WAAW,EAAE,YAAY;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;AACA,kBAAkB,KAAK,wBAAwB,EAAE,EAAE;;AAEnD,4DAA4D;AAC5D;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;;WAES;EACT,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;AACA,6CAA6C,UAAU,EAAE;AACzD,6CAA6C,uBAAuB,EAAE;AACtE,6CAA6C,mBAAmB,EAAE,mBAAmB,EAAE;;AAEvF,4DAA4D;AAC5D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,eAAe,EAAE,gBAAgB;EACjC,0BAA0B;EAC1B,oBAAoB,EAAE,yBAAyB;EAC/C,aAAa;AACf;AACA;;EAEE,WAAW,EAAE,SAAO,EAAE,WAAW,EAAE,2BAA2B;AAChE;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,OAAO,SAAS,EAAE,yBAAyB,EAAE;EAC7C,OAAO,SAAS,EAAE,uBAAuB,EAAE;AAC7C;AACA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,WAAW;EACX,+BAA+B;EAC/B,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,iCAAiC;EACjC,8BAA8B;EAC9B,yCAAyC;EACzC,cAAc,EAAE,4BAA4B;AAC9C;;AAEA,gCAAgC;AAChC,iBAAiB,eAAe,EAAE;AAClC,6BAA6B,aAAa,EAAE;AAC5C,6BAA6B,gBAAgB,EAAE;AAC/C,sBAAsB,oBAAoB,EAAE,gBAAgB,EAAE;AAC9D;EACE,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB;EACzD,oBAAoB,EAAE,yBAAyB;EAC/C,eAAe,EAAE,mBAAmB;EACpC,wCAAwC;AAC1C;AACA,mBAAmB,WAAW,EAAE,qCAAqC,EAAE,aAAa,EAAE;AACtF,mBAAmB,oBAAoB,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;AACjG,mBAAmB,0BAA0B,EAAE,iBAAiB,EAAE;AAClE;mBACmB,aAAa,EAAE,kBAAkB,EAAE;AACtD,mBAAmB,aAAa,EAAE;;AAElC,kBAAkB;AAClB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,wDAAwD;AAC1D;AACA;EACE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,iBAAiB,EAAE,cAAc;EACjC,+BAA+B;AACjC;AACA,gDAAgD,sBAAsB,EAAE;;AAExE,iBAAiB;AACjB;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB,EAAE,gBAAgB;EACnC,0BAA0B;EAC1B,yBAAyB,EAAE,oBAAoB;AACjD;AACA;EACE,iBAAiB,EAAE,gBAAgB;EACnC,oBAAoB,EAAE,gBAAgB;AACxC;AACA;EACE,eAAe,EAAE,wBAAwB;EACzC,gBAAgB,EAAE,eAAe;EACjC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa,EAAE,mBAAmB;EAClC,QAAQ,EAAE,eAAe,EAAE,eAAe;AAC5C;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB;AAC3D;AACA;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,6BAA6B;AAC/B;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,mBAAmB;EACrC,mBAAmB,EAAE,cAAc;EACnC,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,aAAa,EAAE,SAAS,EAAE,mBAAmB;EAC7C,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB,EAAE,aAAa;EAChC,kCAAkC;AACpC;AACA,yBAAyB,gCAAgC,EAAE;;AAE3D;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB,EAAE,gBAAgB;EACpC,cAAc;EACd,0BAA0B;EAC1B,aAAa,EAAE,mBAAmB;EAClC,uBAAuB,EAAE,eAAe;AAC1C;AACA;EACE,WAAW,EAAE,YAAY;EACzB,iBAAiB,EAAE,cAAc;AACnC;AACA,aAAa,SAAO,EAAE,YAAY,EAAE;AACpC;EACE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB;EACvD,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;AAChE;AACA,aAAa,iBAAiB,EAAE,wBAAwB,EAAE,eAAe,EAAE;AAC3E,aAAa,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,cAAc,EAAE;;AAExF,mBAAmB;AACnB;EACE,aAAa,EAAE,8BAA8B;EAC7C,oBAAoB;EACpB,qCAAqC;EACrC,eAAe;EACf,iBAAiB,EAAE,gBAAgB,EAAE,oBAAoB;AAC3D;AACA,qBAAqB,oBAAoB,EAAE;;AAE3C,2DAA2D;AAC3D;EACE,oBAAoB,EAAE,mBAAmB;EACzC,QAAQ,EAAE,kBAAkB,EAAE,sBAAsB;AACtD;AACA;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,mBAAmB;EACnB,4CAA4C;AAC9C;AACA,4BAA4B,oBAAoB,EAAE,wBAAwB,EAAE;AAC5E,4BAA4B,oBAAoB,EAAE,wBAAwB,EAAE;AAC5E;EACE,cAAc,oBAAoB,EAAE,UAAU,EAAE;EAChD,eAAe,oBAAoB,EAAE,SAAS,EAAE;AAClD;;AAEA,4DAA4D;AAC5D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc,EAAE,kBAAkB,EAAE,UAAU;AAChD;AACA;EACE,SAAO,EAAE,kBAAkB;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,wBAAwB,EAAE,eAAe;EACzC,oBAAoB,EAAE,4BAA4B;EAClD,aAAa,EAAE,0BAA0B;EACzC,sDAAsD;AACxD;AACA,oCAAoC,0BAA0B,EAAE;AAChE;EACE,2BAA2B,EAAE,gBAAgB;EAC7C,0CAA0C;AAC5C;AACA,gCAAgC,WAAW,EAAE,mBAAmB,EAAE;;AAElE;EACE,WAAW,EAAE,YAAY,EAAE,cAAc;EACzC,mBAAmB,EAAE,YAAY;EACjC,6DAA6D;EAC7D,WAAW,EAAE,eAAe;EAC5B,aAAa,EAAE,mBAAmB,EAAE,eAAe;EACnD,2CAA2C;EAC3C,6FAA6F;AAC/F;AACA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;AACA,sCAAsC,qBAAqB,EAAE;AAC7D;EACE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB;AACtE;;AAEA,4DAA4D;AAC5D;EACE;IACE,0BAA0B,EAAE,2BAA2B;EACzD;AACF;;AAEA,4DAA4D;AAC5D;EACE,qBAAqB,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,YAAY,EAAE;EAC3E;IACE,UAAU,EAAE,SAAS,EAAE,WAAW;IAClC,YAAY,EAAE,4BAA4B,EAAE,mBAAmB;EACjE;AACF;;AAEA;;;6DAG6D;;AAE7D,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,sCAAsC;EACtC,sCAAsC;EACtC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,YAAY;AACZ,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;;AAEvD,yBAAyB;AACzB,mBAAmB,cAAc,EAAE;;AAEnC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;AACA;;;yDAGyD;;AAEzD;EACE;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,SAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,wDAAwD;EACxD;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;IACjC,6BAA6B;IAC7B,iEAAiE;IACjE,2BAA2B;IAC3B,wCAAwC;IACxC,2BAA2B;IAC3B,oBAAoB;IACpB,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA,yCAAyC;EACzC;IACE,oBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,qDAAqD;EACrD;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,wBAAwB;EAC1B;AACF;AACA;;wDAEwD;AACxD;EACE,eAAe;EACf,YAAY,OAAO,oDAAoD;EACvE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wEAAwE;EACxE,wEAAwE;EACxE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,uEAAuE;EACvE,oDAAoD;EACpD,gBAAgB;AAClB;AACA;EACE,OAAO,UAAU,EAAE,qCAAqC,EAAE;EAC1D,OAAO,UAAU,EAAE,mCAAmC,IAAI;AAC5D;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;;yDAGyD;;AAEzD,sDAAsD;AACtD;;;EAGE,wBAAwB;AAC1B;;AAEA,8DAA8D;AAC9D;;EAEE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,iEAAiE;AACjE;EACE,uBAAuB,EAAE,8BAA8B;AACzD;;AAEA,uDAAuD;AACvD;;EAEE,iBAAiB;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');\n\n/* ═══════════════════════════════════════════════════════\n   PYATE CHATBOT — LIGHT THEME\n   Matches store palette: navy #1b4f72, blue #1e7ab8, white\n═══════════════════════════════════════════════════════ */\n:root {\n  --p-navy:       #1b4f72;\n  --p-blue:       #1e7ab8;\n  --p-light:      #e8f4fd;\n  --p-lighter:    #f0f8ff;\n  --p-border:     #cce3f5;\n  --p-border-dk:  #93c5e8;\n  --p-text:       #1a2e3d;\n  --p-text-sec:   #3d6278;\n  --p-text-muted: #7a9ab0;\n  --p-white:      #ffffff;\n  --p-card:       #f7fbff;\n  --font: 'Sora', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* shimmer keyframe used by .skel */\n@keyframes shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ═══ FLOATING BUTTON ══════════════════════════════════ */\n.chatbot-button {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  z-index: 999;           /* below navbar (1000+) */\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(145deg, #2196c4 0%, #1b5e8c 100%);\n  box-shadow: 0 4px 20px rgba(30,122,184,0.5), 0 2px 8px rgba(0,0,0,.12);\n  transition: transform .25s cubic-bezier(.34,1.56,.64,1), box-shadow .25s ease;\n  animation: fabPulse 3s ease-in-out infinite;\n  isolation: isolate;\n}\n.chatbot-button::before {\n  content: '';\n  position: absolute;\n  inset: -6px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(33,150,196,.2) 0%, transparent 70%);\n  z-index: -1;\n  animation: fabGlow 3s ease-in-out infinite;\n}\n@keyframes fabPulse {\n  0%,100% { box-shadow: 0 4px 20px rgba(30,122,184,.5), 0 2px 8px rgba(0,0,0,.12); }\n  50%      { box-shadow: 0 4px 28px rgba(30,122,184,.72), 0 2px 8px rgba(0,0,0,.12); }\n}\n@keyframes fabGlow {\n  0%,100% { opacity:.5; transform:scale(1); }\n  50%      { opacity:1;  transform:scale(1.12); }\n}\n.chatbot-button:hover {\n  transform: translateY(-3px) scale(1.06);\n  box-shadow: 0 8px 28px rgba(30,122,184,.6), 0 4px 12px rgba(0,0,0,.16);\n}\n.chatbot-button-icon { font-size: 22px; line-height: 1; color: #fff; }\n\n/* ═══ CHAT WINDOW ══════════════════════════════════════\n   z-index 998 — safely below navbar (typically 1000+)\n══════════════════════════════════════════════════════ */\n.chatbot-container {\n  position: fixed;\n  bottom: 90px;\n  right: 24px;\n  width: min(400px, calc(100vw - 32px));\n  height: min(480px, calc(100vh - 160px));\n  z-index: 998;\n  background: var(--p-white);\n  border-radius: 20px;\n  border: 1px solid var(--p-border);\n  box-shadow:\n    0 0 0 1px rgba(30,122,184,.07),\n    0 20px 60px rgba(27,78,114,.16),\n    0 8px 24px rgba(0,0,0,.09);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: var(--font);\n  animation: chatOpen .3s cubic-bezier(.22,1,.36,1);\n}\n/* colour bar top */\n.chatbot-container::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #1b5e8c, #2196c4, #38bdf8, #2196c4, #1b5e8c);\n  z-index: 2;\n}\n@keyframes chatOpen {\n  from { transform: translateY(20px) scale(.97); opacity: 0; }\n  to   { transform: translateY(0)    scale(1);   opacity: 1; }\n}\n\n/* ═══ HEADER ═══════════════════════════════════════════ */\n.chatbot-header {\n  padding: 13px 15px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #1b5e8c 0%, #1e7ab8 100%);\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1;\n}\n.chatbot-header-left   { display: flex; align-items: center; gap: 10px; }\n.chatbot-avatar {\n  width: 36px; height: 36px; border-radius: 10px;\n  background: rgba(255,255,255,.18);\n  border: 1.5px solid rgba(255,255,255,.3);\n  display: grid; place-items: center;\n  font-size: 17px; flex-shrink: 0;\n}\n.chatbot-header-titles { display: flex; flex-direction: column; gap: 2px; }\n.chatbot-header h4 {\n  margin: 0; font-size: 14px; font-weight: 700;\n  color: #fff; letter-spacing: .1px;\n}\n.chatbot-subtitle {\n  font-size: 11px; color: rgba(255,255,255,.88);\n  display: flex; align-items: center; gap: 5px;\n}\n.chatbot-subtitle::before {\n  content: ''; width: 6px; height: 6px; border-radius: 50%;\n  background: #4ade80; box-shadow: 0 0 5px rgba(74,222,128,.8);\n  animation: onlinePulse 2s ease-in-out infinite; flex-shrink: 0;\n}\n@keyframes onlinePulse { 0%,100%{opacity:1} 50%{opacity:.45} }\n.close-btn-chat {\n  background: inherit;\n  align-content: center;\n  border: 1.5px solid rgba(30,122,184,.72);\n  color: #fff;\n  width: 32px; height: 32px;\n  border-radius: 50%;          /* circular — cleaner look */\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  display: grid; place-items: center;\n  line-height: 1;\n  transition: background .2s ease, transform .2s ease, border-color .2s ease;\n  flex-shrink: 0;\n}\n.close-btn-chat:hover {\n  background: rgba(30,122,184,.72);   /* red on hover */\n  border-color: rgba(30,122,184,.72);\n  color: white;\n}\n\n/* ═══ STATUS BAR ════════════════════════════════════════ */\n.chatbot-status-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  background: #eff8ff;\n  border-bottom: 1px solid #bfdbf7;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--p-blue);\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1;\n  animation: statusIn .2s ease;\n}\n@keyframes statusIn {\n  from { opacity:0; transform:translateY(-4px); }\n  to   { opacity:1; transform:translateY(0); }\n}\n.status-spinner {\n  width: 13px; height: 13px;\n  border: 2px solid #bfdbf7;\n  border-top-color: var(--p-blue);\n  border-radius: 50%;\n  animation: spin .65s linear infinite;\n  flex-shrink: 0;\n}\n@keyframes spin { to { transform:rotate(360deg); } }\n\n/* ═══ MESSAGES AREA ═════════════════════════════════════ */\n.chatbot-messages {\n  flex: 1;\n  padding: 14px 12px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background:\n    radial-gradient(ellipse 70% 50% at 0% 0%, rgba(33,150,196,.04) 0%, transparent 60%),\n    #f8fcff;\n  scrollbar-width: thin;\n  scrollbar-color: #bfdbf7 transparent;\n  position: relative;\n  z-index: 1;\n}\n.chatbot-messages::-webkit-scrollbar       { width: 4px; }\n.chatbot-messages::-webkit-scrollbar-track { background: transparent; }\n.chatbot-messages::-webkit-scrollbar-thumb { background: #bfdbf7; border-radius: 99px; }\n\n/* ═══ DATE DIVIDER ══════════════════════════════════════ */\n.chat-divider {\n  display: flex; align-items: center; gap: 8px;\n  font-size: 10px; font-weight: 600;\n  color: var(--p-text-muted);\n  letter-spacing: .6px; text-transform: uppercase;\n  margin: 2px 0;\n}\n.chat-divider::before,\n.chat-divider::after {\n  content: ''; flex: 1; height: 1px; background: var(--p-border);\n}\n\n/* ═══ MESSAGE BUBBLES ═══════════════════════════════════ */\n.message {\n  max-width: 84%;\n  padding: 9px 13px;\n  border-radius: 14px;\n  font-size: 13px;\n  line-height: 1.55;\n  word-break: break-word;\n  position: relative;\n  animation: msgIn .25s cubic-bezier(.22,1,.36,1);\n}\n@keyframes msgIn {\n  from { opacity:0; transform:translateY(8px); }\n  to   { opacity:1; transform:translateY(0); }\n}\n.message.user {\n  align-self: flex-end;\n  background: linear-gradient(135deg, #1e7ab8 0%, #1b5e8c 100%);\n  color: #fff;\n  border-bottom-right-radius: 4px;\n  box-shadow: 0 3px 12px rgba(30,122,184,.28);\n}\n.message.bot {\n  align-self: flex-start;\n  background: var(--p-white);\n  color: var(--p-text);\n  border: 1px solid var(--p-border);\n  border-bottom-left-radius: 4px;\n  box-shadow: 0 2px 8px rgba(27,78,114,.07);\n  max-width: 92%; /* wider for product cards */\n}\n\n/* markdown inside bot bubbles */\n.message.bot p { margin: .28em 0; }\n.message.bot p:first-child { margin-top: 0; }\n.message.bot p:last-child  { margin-bottom: 0; }\n.message.bot strong { color: var(--p-navy); font-weight: 700; }\n.message.bot h3 {\n  font-size: 10.5px; font-weight: 700; color: var(--p-blue);\n  letter-spacing: .5px; text-transform: uppercase;\n  margin: 0 0 8px; padding-bottom: 6px;\n  border-bottom: 1px solid var(--p-border);\n}\n.message.bot hr  { border:none; border-top: 1px solid var(--p-border); margin: 8px 0; }\n.message.bot a   { color: var(--p-blue); text-decoration: underline; text-underline-offset: 2px; }\n.message.bot del { color: var(--p-text-muted); font-size: 11.5px; }\n.message.bot ul,\n.message.bot ol  { margin: 4px 0; padding-left: 16px; }\n.message.bot li  { margin: 2px 0; }\n\n/* error variant */\n.message.error-msg {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b91c1c;\n}\n\n/* ═══ SKELETON SHIMMER ══════════════════════════════════ */\n.skel {\n  background: linear-gradient(90deg, #dbeafe 25%, #eff8ff 50%, #dbeafe 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n  border-radius: 6px;\n  display: block;\n}\n\n/* ═══ PRODUCT CARD ══════════════════════════════════════ */\n.pyate-product-card {\n  background: var(--p-card);\n  border: 1px solid var(--p-border);\n  border-radius: 12px;\n  overflow: hidden;\n  margin: 6px 0;\n  transition: border-color .18s ease, box-shadow .18s ease;\n}\n.pyate-product-card:hover {\n  border-color: var(--p-border-dk);\n  box-shadow: 0 4px 16px rgba(27,78,114,.1);\n}\n\n/* image wrapper */\n.pcard-img-wrap {\n  width: 100%;\n  height: 140px;\n  background: var(--p-light);\n  overflow: hidden;\n}\n.pcard-img-wrap img {\n  width: 100%; height: 100%;\n  object-fit: cover; display: block;\n  transition: transform .25s ease;\n}\n.pyate-product-card:hover .pcard-img-wrap img { transform: scale(1.04); }\n\n/* info section */\n.pcard-body {\n  padding: 10px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.pcard-category {\n  font-size: 10.5px; font-weight: 600;\n  color: var(--p-text-muted);\n  text-transform: uppercase; letter-spacing: .4px;\n}\n.pcard-name {\n  font-size: 13.5px; font-weight: 700;\n  color: var(--p-navy); line-height: 1.3;\n}\n.pcard-desc {\n  font-size: 12px; color: var(--p-text-sec);\n  line-height: 1.4; margin-top: 2px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.pcard-price-row {\n  display: flex; align-items: center;\n  gap: 6px; flex-wrap: wrap; margin-top: 6px;\n}\n.pcard-price {\n  font-size: 14.5px; font-weight: 700; color: var(--p-navy);\n}\n.pcard-mrp {\n  font-size: 11.5px; color: var(--p-text-muted);\n  text-decoration: line-through;\n}\n.pcard-badge {\n  font-size: 10px; font-weight: 700;\n  padding: 1px 7px; border-radius: 99px;\n  background: #dcfce7; color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n/* ═══ CART ITEM ROW ════════════════════════════════════ */\n.pyate-cart-item {\n  display: flex; gap: 10px; align-items: center;\n  background: var(--p-card);\n  border: 1px solid var(--p-border);\n  border-radius: 12px;\n  padding: 9px 11px; margin: 4px 0;\n  transition: border-color .18s ease;\n}\n.pyate-cart-item:hover { border-color: var(--p-border-dk); }\n\n.ci-img {\n  width: 52px; height: 52px;\n  border-radius: 8px; overflow: hidden;\n  flex-shrink: 0;\n  background: var(--p-light);\n  display: flex; align-items: center;\n  justify-content: center; font-size: 20px;\n}\n.ci-img img {\n  width: 100%; height: 100%;\n  object-fit: cover; display: block;\n}\n.ci-info   { flex: 1; min-width: 0; }\n.ci-name   {\n  font-size: 13px; font-weight: 600; color: var(--p-navy);\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n}\n.ci-qty    { font-size: 11.5px; color: var(--p-text-sec); margin-top: 2px; }\n.ci-price  { font-size: 13.5px; font-weight: 700; color: var(--p-blue); flex-shrink: 0; }\n\n/* cart total row */\n.cart-total {\n  display: flex; justify-content: space-between;\n  padding: 8px 4px 2px;\n  border-top: 1px solid var(--p-border);\n  margin-top: 4px;\n  font-size: 13.5px; font-weight: 700; color: var(--p-navy);\n}\n.cart-total-amount { color: var(--p-blue); }\n\n/* ═══ TYPING DOTS ══════════════════════════════════════ */\n.message.bot.typing {\n  display: inline-flex; align-items: center;\n  gap: 5px; padding: 11px 15px; max-width: fit-content;\n}\n.typing span {\n  width: 7px; height: 7px; border-radius: 50%;\n  background: #93c5e8;\n  animation: typeDot 1.4s ease-in-out infinite;\n}\n.typing span:nth-child(2) { animation-delay:.18s; background:var(--p-blue); }\n.typing span:nth-child(3) { animation-delay:.36s; background:var(--p-navy); }\n@keyframes typeDot {\n  0%,80%,100% { transform:scale(.65); opacity:.4; }\n  40%          { transform:scale(1.1); opacity:1; }\n}\n\n/* ═══ INPUT AREA ════════════════════════════════════════ */\n.chatbot-input {\n  display: flex; align-items: center; gap: 8px;\n  padding: 10px 11px;\n  background: #fff;\n  border-top: 1px solid var(--p-border);\n  flex-shrink: 0; position: relative; z-index: 1;\n}\n.chatbot-input input {\n  flex: 1; padding: 10px 14px;\n  border: 1.5px solid var(--p-border);\n  border-radius: 12px;\n  font-family: var(--font); font-size: 13px;\n  color: var(--p-text); background: var(--p-lighter);\n  outline: none; caret-color: var(--p-blue);\n  transition: border-color .2s ease, box-shadow .2s ease;\n}\n.chatbot-input input::placeholder { color: var(--p-text-muted); }\n.chatbot-input input:focus {\n  border-color: var(--p-blue); background: #fff;\n  box-shadow: 0 0 0 3px rgba(30,122,184,.12);\n}\n.chatbot-input input:disabled { opacity: .6; cursor: not-allowed; }\n\n.chatbot-send {\n  width: 40px; height: 40px; flex-shrink: 0;\n  border-radius: 11px; border: none;\n  background: linear-gradient(135deg, #2196c4 0%, #1b5e8c 100%);\n  color: #fff; cursor: pointer;\n  display: grid; place-items: center; font-size: 15px;\n  box-shadow: 0 3px 12px rgba(30,122,184,.35);\n  transition: transform .2s cubic-bezier(.34,1.56,.64,1), box-shadow .2s ease, opacity .2s ease;\n}\n.chatbot-send:hover:not(:disabled) {\n  transform: translateY(-2px) scale(1.05);\n  box-shadow: 0 6px 18px rgba(30,122,184,.45);\n}\n.chatbot-send:active:not(:disabled) { transform: scale(.95); }\n.chatbot-send:disabled {\n  opacity: .35; cursor: not-allowed; transform: none; box-shadow: none;\n}\n\n/* ═══ REDUCED MOTION ════════════════════════════════════ */\n@media (prefers-reduced-motion: reduce) {\n  *, .chatbot-button, .chatbot-container, .message {\n    animation: none !important; transition: none !important;\n  }\n}\n\n/* ═══ MOBILE ════════════════════════════════════════════ */\n@media (max-width: 520px) {\n  .chatbot-button    { right: 14px; bottom: 14px; width: 52px; height: 52px; }\n  .chatbot-container {\n    right: 8px; left: 8px; width: auto;\n    bottom: 78px; height: calc(100svh - 140px); border-radius: 16px;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════\n   NOTIFICATION-STYLE CARDS  —  append these to Chatbot.css\n   Matches the look of Notifications.js cards exactly\n═══════════════════════════════════════════════════════════ */\n\n/* ── Card list wrapper ── */\n.notif-cb-cards-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 6px;\n  width: 100%;\n}\n\n/* ── Single card  (mirrors .notification-item) ── */\n.notif-cb-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 11px;\n  background: #ffffff;\n  border: 1px solid #e0e3e8;\n  border-left: 4px solid #1a73e8;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n  animation: notif-cb-in 0.22s ease both;\n  font-family: 'DM Sans', sans-serif;\n  overflow: hidden;\n}\n\n@keyframes notif-cb-in {\n  from { opacity: 0; transform: translateY(5px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.notif-cb-card:hover {\n  background: #f5f8ff;\n  border-color: #c8cdd6;\n  border-left-color: #1a73e8;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.1);\n  transform: translateY(-1px);\n}\n\n/* stagger */\n.notif-cb-card:nth-child(1)  { animation-delay: 0.03s; }\n.notif-cb-card:nth-child(2)  { animation-delay: 0.06s; }\n.notif-cb-card:nth-child(3)  { animation-delay: 0.09s; }\n.notif-cb-card:nth-child(4)  { animation-delay: 0.12s; }\n.notif-cb-card:nth-child(5)  { animation-delay: 0.15s; }\n.notif-cb-card:nth-child(6)  { animation-delay: 0.18s; }\n.notif-cb-card:nth-child(7)  { animation-delay: 0.21s; }\n.notif-cb-card:nth-child(8)  { animation-delay: 0.24s; }\n.notif-cb-card:nth-child(9)  { animation-delay: 0.27s; }\n.notif-cb-card:nth-child(10) { animation-delay: 0.30s; }\n\n/* ── Avatar / image ── */\n.notif-cb-avatar { flex-shrink: 0; }\n\n.notif-cb-img {\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  object-fit: cover;\n  border: 1px solid #e0e3e8;\n  display: block;\n}\n\n.notif-cb-img-placeholder {\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  background: #e8f0fe;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #1a73e8;\n  border: 1px solid rgba(26,115,232,0.15);\n}\n\n/* ── Content ── */\n.notif-cb-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notif-cb-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1c1e21;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notif-cb-sub {\n  font-size: 11px;\n  color: #a0a3a9;\n  margin-top: 1px;\n}\n\n.notif-cb-desc {\n  font-size: 11px;\n  color: #65676b;\n  font-style: italic;\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notif-cb-price-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 4px;\n  flex-wrap: wrap;\n}\n\n.notif-cb-price {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #1c1e21;\n}\n\n.notif-cb-mrp {\n  font-size: 11px;\n  color: #a0a3a9;\n  text-decoration: line-through;\n}\n\n.notif-cb-discount {\n  font-size: 11px;\n  font-weight: 600;\n  color: #2e7d32;\n}\n\n.notif-cb-qty {\n  font-size: 11px;\n  color: #65676b;\n  background: #f0f2f5;\n  border: 1px solid #e0e3e8;\n  padding: 1px 6px;\n  border-radius: 100px;\n}\n\n.notif-cb-date {\n  font-size: 10.5px;\n  color: #a0a3a9;\n}\n\n/* ── Add to cart button ── */\n.notif-cb-action-btn {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 11px;\n  background: #1a73e8;\n  color: #fff;\n  border: none;\n  border-radius: 100px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  box-shadow: 0 2px 8px rgba(26,115,232,0.18);\n  white-space: nowrap;\n}\n\n.notif-cb-action-btn:hover {\n  background: #1558b0;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px rgba(26,115,232,0.25);\n}\n\n/* ── Status / label badges ── */\n.notif-cb-badge {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 9px;\n  border-radius: 100px;\n  white-space: nowrap;\n}\n\n.notif-cb-badge-cart {\n  background: #e8f0fe;\n  color: #1a73e8;\n  border: 1px solid rgba(26,115,232,0.2);\n}\n\n.notif-cb-badge-pending {\n  background: #fff3e0;\n  color: #e65100;\n  border: 1px solid rgba(230,81,0,0.2);\n}\n\n.notif-cb-badge-delivered {\n  background: #e8f5e9;\n  color: #2e7d32;\n  border: 1px solid rgba(46,125,50,0.2);\n}\n\n.notif-cb-badge-shipped {\n  background: #e3f2fd;\n  color: #1565c0;\n  border: 1px solid rgba(21,101,192,0.2);\n}\n/* ═══════════════════════════════════════════════════════\n   CHATBOT MOBILE FULLSCREEN FIX — append to Chatbot.css\n   Fixes clipped send button + full screen on mobile\n═══════════════════════════════════════════════════════ */\n\n@media (max-width: 768px) {\n  .chatbot-container {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100vh !important;\n    height: 100dvh !important;\n    max-width: 100% !important;\n    max-height: 100% !important;\n    border-radius: 0 !important;\n    z-index: 9999 !important;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden !important;\n  }\n\n  .chatbot-messages {\n    flex: 1 1 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Input row — no clipping, full width, proper padding */\n  .chatbot-input {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n    padding: 10px 12px !important;\n    padding-bottom: max(10px, env(safe-area-inset-bottom)) !important;\n    background: #fff !important;\n    border-top: 1px solid #e0e3e8 !important;\n    position: sticky !important;\n    bottom: 0 !important;\n    z-index: 10000 !important;\n    overflow: visible !important;\n  }\n\n  /* Text input takes all available space */\n  .chatbot-input input {\n    flex: 1 1 0 !important;\n    min-width: 0 !important;\n    width: 0 !important;\n  }\n\n  /* Send button — fixed size, never shrinks or clips */\n  .chatbot-send {\n    flex-shrink: 0 !important;\n    width: 42px !important;\n    height: 42px !important;\n    min-width: 42px !important;\n    border-radius: 50% !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n\n  .chatbot-button {\n    z-index: 9998 !important;\n  }\n}\n/* ═══ LANGUAGE FAB ══════════════════════════════════════\n   Floats above the chat button, same right-edge alignment\n══════════════════════════════════════════════════════ */\n.lang-fab-wrap {\n  position: fixed;\n  bottom: 92px;      /* sits just above the 56px chat button + 24px gap */\n  right: 24px;\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.lang-fab-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 7px 13px;\n  border-radius: 99px;\n  border: 1.5px solid rgba(30,122,184,0.35);\n  background: #fff;\n  color: #1e7ab8;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 12px rgba(30,122,184,0.18), 0 1px 4px rgba(0,0,0,0.08);\n  transition: transform .2s ease, box-shadow .2s ease, background .2s ease;\n  white-space: nowrap;\n}\n.lang-fab-btn:hover {\n  background: #e8f4fd;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 18px rgba(30,122,184,0.28);\n}\n\n/* dropdown menu */\n.lang-fab-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #fff;\n  border: 1px solid #cce3f5;\n  border-radius: 12px;\n  padding: 6px;\n  box-shadow: 0 8px 28px rgba(27,78,114,0.14), 0 2px 8px rgba(0,0,0,0.08);\n  animation: langMenuIn .18s cubic-bezier(.22,1,.36,1);\n  min-width: 120px;\n}\n@keyframes langMenuIn {\n  from { opacity: 0; transform: translateY(6px) scale(.97); }\n  to   { opacity: 1; transform: translateY(0)   scale(1);   }\n}\n\n.lang-fab-option {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #1a2e3d;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  transition: background .15s ease, color .15s ease;\n}\n.lang-fab-option:hover {\n  background: #e8f4fd;\n  color: #1e7ab8;\n}\n.lang-fab-option.active {\n  background: #1e7ab8;\n  color: #fff;\n  font-weight: 700;\n}\n\n/* mobile adjustments */\n@media (max-width: 520px) {\n  .lang-fab-wrap {\n    right: 14px;\n    bottom: 80px;\n  }\n}\n\n/* ═══ GOOGLE TRANSLATE CONFLICT FIX ════════════════════\n   Prevents chatbot button duplication when Google Translate\n   toolbar is active (e.g. Kannada selected)\n═══════════════════════════════════════════════════════ */\n\n/* Stop Google Translate from cloning fixed elements */\n.skiptranslate .chatbot-button,\n.skiptranslate .chatbot-container,\n.skiptranslate .lang-fab-wrap {\n  display: none !important;\n}\n\n/* When translate bar pushes body down, keep button anchored */\nbody.translated-ltr .chatbot-button,\nbody.translated-rtl .chatbot-button {\n  bottom: 24px !important;\n  position: fixed !important;\n}\n\n/* Prevent the translate frame from overlapping the chat window */\n.goog-te-banner-frame {\n  z-index: 997 !important; /* below chatbot z-index 998 */\n}\n\n/* Neutralize body top shift Google Translate applies */\nbody.translated-ltr,\nbody.translated-rtl {\n  top: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
